import { render } from "./SupplierInformation.vue?vue&type=template&id=ba6dc7c4&scoped=true"
import script from "./SupplierInformation.vue?vue&type=script&lang=js"
export * from "./SupplierInformation.vue?vue&type=script&lang=js"

import "./SupplierInformation.vue?vue&type=style&index=0&id=ba6dc7c4&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6dc7c4"]])

export default __exports__